import { METERS_TO_FEET, FEET_PER_MILE } from './units';
// Largest 1 / 2 / 5 x 10^n value not exceeding `value`.
const niceRound = (value) => {
    const pow = Math.pow(10, Math.floor(Math.log10(value)));
    const f = value / pow;
    const nice = f >= 5 ? 5 : f >= 2 ? 2 : 1;
    return nice * pow;
};
const trim = (n) => Number(n.toFixed(2)).toString();
// Given the live ground resolution (metres per screen pixel) and a maximum bar
// width, pick a clean round distance that fits within that width and return its
// label plus the exact pixel width that represents it. Returns null for
// degenerate input (e.g. camera looking at the sky).
export const computeNiceScale = (metersPerPixel, maxWidthPx, system) => {
    if (!isFinite(metersPerPixel) || metersPerPixel <= 0 || maxWidthPx <= 0)
        return null;
    const maxMeters = metersPerPixel * maxWidthPx;
    if (system === 'imperial') {
        const maxFeet = maxMeters * METERS_TO_FEET;
        if (maxFeet >= FEET_PER_MILE) {
            const niceMiles = niceRound(maxFeet / FEET_PER_MILE);
            const meters = (niceMiles * FEET_PER_MILE) / METERS_TO_FEET;
            return { label: `${trim(niceMiles)} mi`, widthPx: meters / metersPerPixel };
        }
        const niceFeet = niceRound(maxFeet);
        return { label: `${trim(niceFeet)} ft`, widthPx: niceFeet / METERS_TO_FEET / metersPerPixel };
    }
    if (maxMeters >= 1000) {
        const niceKm = niceRound(maxMeters / 1000);
        return { label: `${trim(niceKm)} km`, widthPx: (niceKm * 1000) / metersPerPixel };
    }
    const niceM = niceRound(maxMeters);
    return { label: `${trim(niceM)} m`, widthPx: niceM / metersPerPixel };
};
